"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Car = function Car() {
  return _react2.default.createElement(
    "g",
    { id: "car" },
    _react2.default.createElement("path", {
      d: "M442.150309,58.6144618 C436.235031,41.937993 420.392661,30.8495879 402.698819,31.0015424 L97.1449991,31.0015424 C79.4776153,30.9344454 63.6794569,41.9919054 57.6935091,58.6144618 L0,222.324089 L0,440.978428 C0.17153647,456.172563 12.5741572,468.379867 27.769101,468.31022 L55.538202,468.31022 C70.7383593,468.380014 83.1499824,456.177576 83.3385394,440.978428 L83.3385394,413.646635 L416.661461,413.646635 L416.661461,440.978428 C416.832997,456.172563 429.235618,468.379867 444.430562,468.31022 L472.199663,468.31022 C487.39982,468.380014 499.811443,456.177576 500,440.978428 L500,222.324089 L442.150309,58.6144618 Z M97.1449991,331.651258 C74.5828901,331.290356 56.5503233,312.771349 56.7899687,290.207627 C57.0296141,267.643904 75.4514431,249.512074 98.0161278,249.630455 C120.580813,249.748837 138.811382,268.072956 138.814269,290.637951 C138.74005,301.606363 134.30509,312.094596 126.487788,319.788837 C118.670486,327.483078 108.113207,331.751074 97.1449991,331.651258 L97.1449991,331.651258 Z M402.698819,331.651258 C380.13671,331.290356 362.104144,312.771349 362.343789,290.207627 C362.583434,267.643904 381.005263,249.512074 403.569948,249.630455 C426.134633,249.748837 444.365203,268.072956 444.368089,290.637951 C444.29387,301.606363 439.85891,312.094596 432.041608,319.788837 C424.224306,327.483078 413.667028,331.751074 402.698819,331.651258 Z M55.4757294,194.992296 L97.1449991,72.0148491 L402.698819,72.0148491 L444.368089,194.992296 L55.4757294,194.992296 Z",
      id: "Shape"
    })
  );
};

exports.default = Car;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Car.js
// module id = 2931
// module chunks = 4